import { Grid,makeStyles}              from '@material-ui/core';
import React                           from 'react';

const useStyles =  makeStyles (theme =>({
    ContenedorLectura:{
        width:'502px',
                  [theme.breakpoints.down(502)]:{
            width:'350px',
            padding: '60px 0 0 0',
        },
        [theme.breakpoints.down(350)]:{
            width:'300px',
            padding: '30px 0 0 0',
        },
    },
    ContainerTitulo:{
        margin:'0 0 34px 0',
        '& .Titulo':{
            letterSpacing: '0px',
            color: '#817FD9',
            margin:'0',
            textAlign:'center',
            font:'43px fredoka one',
            lineHeight:'52px',
            [theme.breakpoints.down(502)]:{
                font:'30px fredoka one',
                lineHeight:'32px',
            },
            [theme.breakpoints.down(350)]:{
                font:'28px fredoka one',
                lineHeight:'32px',
            },
        },
    },
    Parrafo1:{
        margin:' 0 0 36px 0',
        '& .Lectura':{
            margin:'0 0 36px 0',
            color:'#000',
            font:'18px lato',
            lineHeight :'28px',
            letterSpacing: '0.17px',
            [theme.breakpoints.down(502)]:{
                font:'16px lato',
                lineHeight :'21px',
                letterSpacing: '0.09px',
            },
            [theme.breakpoints.down(350)]:{
                font:'12px lato',
                lineHeight :'17px',
                letterSpacing: '0.09px',
            },
        },
        "& .SubTitulo": {
            color: "#20A698",
            margin: "0",
            lineHeight: "28px",
            font: "bold 26px lato",
            letterSpacing: "0.24px",
            [theme.breakpoints.down(502)]: {
              font: "bold 22px lato",
              lineHeight: "24px",
              letterSpacing: "0.21px",
            },
        },
        "& .SubTitulo2": {
            color: "#F6664D",
            margin: "0",
            font: "bold 22px lato",
            lineHeight: "24px",
            letterSpacing: "0.21px",
            [theme.breakpoints.down(502)]: {
              font: "bold 18px lato",
              lineHeight: "20px",
              letterSpacing: "0.16px",
            },
        },
        '& .TextImg':{
            color:'#717476',
            font:' 16px lato',
            lineHeight :'25px',
            letterSpacing: '0.15px',
            margin:'20px 0 0 0',
            [theme.breakpoints.down(502)]:{
                font:' 11px lato',
                lineHeight :'14px',
                letterSpacing: '0.10px',
            },
        },
        '& .Imagen':{
            width:'100%',
        }, 
        '& .Imagen2':{
            width:'92.23%',
        }, 
      
      
    }
}));

const Mucha_o_poca_energía_cuánto_podemos_comer = () => {
const classes = useStyles ()
    return (  
        <Grid container item justifyContent="center" xs={12} className={classes.Contenedor}>
            <Grid container item className={classes.ContenedorLectura} justifyContent="center">
                <Grid container item sm={12} className={classes.ContainerTitulo} justifyContent="center">
                    <h2 className="Titulo" >
                    Mucha o poca energía:<br/> ¿cuánto podemos<br/> comer?                  
                    </h2>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                      <p className="Lectura">
                        <h3 className='SubTitulo'>La energía en la vida cotidiana</h3><br/>

                        Todas las actividades que realizas en tu vida cotidiana requieren un aporte constante
                        de energía. Incluso cuando estás durmiendo, cada una de tus células lo necesita para 
                        realizar sus funciones: los latidos del corazón, la circulación sanguínea o el 
                        funcionamiento de tu cerebro dependen de ello.<br/><br/>
                        
                        Como sucede con el resto de los animales, el cuerpo de los seres humanos obtiene su 
                        energía a partir de los alimentos que consume. Así consigue los nutrientes con los 
                        cuales las células producen la energía necesaria para llevar a cabo cualquier 
                        actividad. <br/><br/>
                        
                        Piensa un instante: ¿cuánta energía consideras que necesitas? Si eres muy activo, 
                        seguramente será mucha, ya que ésta se corresponde con nuestro estilo de vida, es 
                        decir, con nuestras costumbres y actividades: a mayor movimiento, mayor energía.
                      </p>
                    </Grid>
                    <Grid container justifyContent="center" sm={12}>
                        <Grid container justifyContent="center" >
                            <img className="Imagen" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img2do/Sesion47/1.png" alt="Tarjeta" />
                        </Grid>
                        <Grid container justifyContent="center" >
                            <p className="TextImg">
                            La cantidad y los tipos de alimentos que consumes debe ser proporcional a la cantidad de actividades y movimiento que realizas.                            </p>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                      <p className="Lectura">
                        <h3 className='SubTitulo2'>Información valiosa</h3><br/>

                         La medida de la energía que proporciona un alimento se expresa en <em>calorías</em>. Cada 
                         alimento aporta cierta cantidad de calorías a tu cuerpo (algunos más y otros menos). 
                         Pero es importante que consideres su calidad con base en otras sustancias 
                         necesarias que no sólo son fuente de energía. Hay algunos cuyo contenido calórico 
                         es muy elevado, pero que no te aportan proteínas u otros nutrientes. Por eso se les 
                         conoce como <em>calorías vacías</em>.
                      </p>
                    </Grid>
                    <Grid container justifyContent="center" >
                        <img className="Imagen2" src="https://img-lecturas-cdl.s3.us-west-1.amazonaws.com/Imagenes+Lecturas/Img2do/Sesion47/2.png" alt="Tarjeta" />
                    </Grid>
                    <Grid container justifyContent="center" >
                        <p className="TextImg">
                            La comida chatarra es un ejemplo de calorías vacías. Por eso no se recomienda su consumo.                           
                        </p>
                    </Grid>
                </Grid>
                
                <Grid container item sm={12} className={classes.Parrafo1} justifyContent="center">
                    <Grid container sm={12}>
                      <p className="Lectura">
                        Es importante consumir alimentos de todos los grupos para tener un aporte 
                        suficiente de energía y de todos los demás nutrimentos necesarios para nuestro 
                        organismo. Éstos varían para cada persona, dependiendo de la edad, el sexo, la 
                        estatura y la actividad física que realiza. En otras palabras: la cantidad y el tipo de 
                        alimentos que consumes deben ser seleccionados cuidadosamente de acuerdo con 
                        tus necesidades particulares. Un nutriólogo podría ayudarte con eso.<br/><br/>
                        
                        Si se excede en el consumo de la cantidad de alimentos que requerimos (y, por lo 
                        tanto, en el aporte calórico), la energía se almacenará en forma de grasa. Esto 
                        propicia el sobrepeso y otras enfermedades relacionadas, como la obesidad y la 
                        diabetes. <br/><br/>
                        
                        ¿Qué tan saludable consideras que es tu dieta? ¿Crees que podrías mejorarla 
                        incorporando alimentos de tu entorno?
                      </p>
                    </Grid>
                </Grid>
        </Grid>
    </Grid>
    );
}
 
export default Mucha_o_poca_energía_cuánto_podemos_comer ;
